import styled from 'styled-components';
import {
  CenteredDivWrap,
  CenteredSpaceWrap,
  SmallSectionHeader,
  ButtonBase,
} from '../../../CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';
import {props} from './__mocks__/paxWidgetMock';

export const WrapperDiv = styled.div`
  position: absolute;
  max-height: 46rem;
  top: 100%;
  width: 58rem;
  background-color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.base};
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  z-index: ${props => props.theme.misc.zIndex.xlarge};
  margin-top: ${props => props.theme.spacing.small};
  ${props => props.customStyle};
`;

export const ContentWrapperDiv = styled.div(
  props => `
  display:flex;
  flex-wrap:wrap;
  border-bottom: 0.1rem solid ${props.theme.colors.ash.medium};
  padding-top: ${props.theme.spacing.xlarge};
`,
);

export const ContentItemWrapperDiv = styled(CenteredDivWrap)(
  props => `
  flex-wrap:wrap;
  width: 33%;
  padding: 0 0 ${props.theme.spacing.large};
  flex-direction: column;
  justify-content: flex-start;
`,
);

export const ContentItemTextWrapperSpan = styled.span`
  padding: 0 0 ${props => props.theme.spacing.base};
  ${textSizes.BaseW3}
`;

export const ContentItemConditionTextWrapperSpan = styled.span(
  props => `
  padding-left: ${props.theme.spacing.small};
  font-size: ${props.theme.font.custom(14)};
  font-weight: normal;
`,
);

export const ContentActionWrapperDiv = styled(CenteredSpaceWrap)(
  props => `
  width: 10.5rem;
  height:4rem;
  padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.base};
  background-color: ${props.theme.colors.goWhite.base};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.13);
  border-radius: ${props.theme.misc.borderRadius.custom(40)};
`,
);

export const ContentActionDropdownWrapper = styled(ContentActionWrapperDiv)(
  props => `
  padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.xlarge};
`,
);

export const ContentActionValueWrapperSpan = styled(SmallSectionHeader)(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const ContentActionIconWrapperSpan = styled.span(
  props => `
  font-size: ${props.theme.font.custom(30)};
  padding: 0 ${props.theme.spacing.small};
  color: ${props.theme.colors.goBrandBlue.base};
  position:relative;
  top:-${props.theme.spacing.custom(3)};
  cursor:pointer;
`,
);

export const ChildDropdownWrap = styled.ul(
  props => `
  z-index: ${props.theme.misc.zIndex.small};
  overflow: scroll;
  height: 20rem;
  display:flex;
  flex-direction:column;
  position:absolute;
  margin-top: 7.5rem;
  width: 9rem;
  background: ${props.theme.colors.goWhite.base};
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  color: ${props.theme.colors.goBrandBlue.base};
  overflow: scroll;
  height: 20rem;

  >li {
    padding: ${props.theme.spacing.base} ${props.theme.spacing.xlarge};
    text-align:center;
    color: ${props.theme.colors.goBrandBlue.base};
    font-weight: 600;
    font-size: ${props.theme.font.custom(18)};
    border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};
    cursor:pointer;
  &:last-child{
    border-bottom:none;
  }
`,
);

export const BottomPersuasionWrapperDiv = styled.div(
  props => `
  display:flex;
  justify-content: flex-end;
  width:100%;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.custom(35)};
  border-top: 1px solid ${props.theme.colors.goBrandBlue.light};
`,
);

export const ButtonWrapperDiv = styled.div(
  props => `
  display:flex;
  justify-content: flex-end;
  width:100%;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.custom(35)};
  border-top: 1px solid ${props.theme.colors.goBrandBlue.light};
  flex-direction:column;
`,
);

export const ButtonWrapper = styled(ButtonBase)(
  props => `
    padding: ${props.theme.spacing.base} ${props.theme.spacing.custom(35)};
    border-radius: ${props.theme.misc.borderRadius.base};
    align-self:flex-end;
    &:disabled{
      background-color: ${props.theme.colors.downriver.light};
      border:0.1rem solid ${props.theme.colors.downriver.light};
      cursor: not-allowed;
    }
`,
);

export const SelectedChildAgeErrorText = styled.p(
  props => `
  font-size: ${props.theme.font.custom(14)};
  padding: 12px 0 ${props.theme.spacing.base};
  color: #FF3A5C;
  `,
);
